import React from "react";
import PropTypes from "prop-types";

const Reset = (props) => {
  return (
    <div>
      <i className="fa fa-retweet reset" aria-hidden="true" onClick = {props.resetGrades}>
        <span>Reset</span>{" "}
      </i>
    </div>
  );
};

Reset.propTypes = {};

export default Reset;
